import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import GitHubIcon from '@mui/icons-material/GitHub';
import Container from '@mui/material/Container';
import { DarkMode, LightMode } from '@mui/icons-material';
import { ThemeContext } from '../providers/ThemeContext';
import { useNavigate } from 'react-router-dom';
import useWindowDimensions from '../hooks/dimension';

interface MyHeaderProps {

}

const MyHeader: React.FunctionComponent<MyHeaderProps> = () => {

    const { darkMode, changeTheme } = React.useContext(ThemeContext);
    const navigate = useNavigate();
    const { height, width } = useWindowDimensions();

    const onChangeTheme = () => {
        changeTheme()
    }

    const goToHome = () => {
        navigate('/')
    }

    return (
        <AppBar position='static'>
            <Container style={{
                padding: (width && width < 800) ? 0 : 35,
                paddingInline: (width && width < 800) ? 0 : 45,
            }}>
                <Toolbar>
                    <IconButton
                        size='large'
                        edge='start'
                        aria-label='menu'
                        sx={{ mr: 2 }}
                        color='inherit'
                        onClick={goToHome}
                    >
                        <GitHubIcon fontSize='large' />
                    </IconButton>
                    <Typography variant='h6' component='div' sx={{ flexGrow: 1 }} style={{ color: 'white', fontSize: (width && width < 400) ? 16 : (width && width < 480) ? 18 : (width && width < 600) ? 20 : 24 }}>
                        GitHub Profile Generator
                    </Typography>

                    <div>
                        <IconButton
                            size='large'
                            aria-controls='menu-appbar'
                            aria-haspopup='true'
                            onClick={() => onChangeTheme()}
                            color='inherit'
                        >
                            {darkMode ? <LightMode /> : <DarkMode />}
                        </IconButton>
                    </div>
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default MyHeader;


